var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`tooltip tooltip--${_vm.itemClass}`},[_c('div',{staticClass:"tooltip__title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.data.title))+" ")]),_c('div',{staticClass:"tooltip__description"},[_vm._v(" "+_vm._s(_vm.$t(_vm.data.description))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }